import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { PendingWithdrawals, WithdrawProcedureWrapper } from 'src/domains/players/webview/components/Account';
import { action, observable, makeObservable } from 'mobx';
import { WithdrawFailuresType } from 'src/domains/players/webview/components/WithdrawAndDeposit/withdrawProcedure/withdraw/WithdrawJourney';
import { WithdrawPraxisProviderProcedure } from './WithdrawPraxisProviderProcedure';
import { WithdrawIssue } from 'src/domains/players/webview/components/WithdrawAndDeposit/withdrawProcedure/withdrawProcedureParts/withdrawIssue/WithdrawIssue';
import { WithdrawSuccess } from 'src/domains/players/webview/components/WithdrawAndDeposit/withdrawProcedure/withdrawProcedureParts/withdrawSuccess/WithdrawSuccess';
import { WithdrawPraxisProviderState } from './WithdrawPraxisProvider.state';
import { PraxisIframeStyle } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/praxisProvider/PraxisTab.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AccountState } from 'src/domains/players/shared/Types';

export type WithdrawPraxisProviderStepsType =
    | {
          readonly type: 'set-card';
      }
    | {
          readonly type: 'failure-view';
          readonly failureType: WithdrawFailuresType;
      }
    | {
          type: 'withdraw-pending';
      }
    | {
          type: 'iframe';
          url: string;
      };

export class WithdrawPraxisProviderSteps {
    @observable.ref public step: WithdrawPraxisProviderStepsType;

    public constructor() {
        makeObservable(this);
        this.step = {
            type: 'set-card',
        };
    }

    @action public redirectToSetCard = (): void => {
        this.step = {
            type: 'set-card',
        };
    };

    @action public redirectToIframe = (iframeUrl: string): void => {
        this.step = {
            type: 'iframe',
            url: iframeUrl,
        };
    };

    @action public redirectToFailureView = (failureType: WithdrawFailuresType): void => {
        this.step = {
            type: 'failure-view',
            failureType,
        };
    };

    @action public redirectToPending = (): void => {
        this.step = {
            type: 'withdraw-pending',
        };
    };
}

export const WithdrawPraxisProvider = observer('WithdrawPraxisProvider', () => {
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);
    const accountState = AccountState.get(common);

    const [state] = useState(() => new WithdrawPraxisProviderState(configComponents, accountState, common.trpcClient));

    switch (state.currentStep.type) {
        case 'set-card':
            return (
                <>
                    <WithdrawProcedureWrapper data-test='praxis-withdraw-procedure-wrapper'>
                        <WithdrawPraxisProviderProcedure state={state} />
                    </WithdrawProcedureWrapper>
                    <PendingWithdrawals />
                </>
            );
        case 'iframe':
            return (
                <PraxisIframeStyle
                    isSignup={false}
                    src={state.currentStep.url}
                    dataTest='praxis-iframe'
                />
            );
        case 'failure-view':
            return <WithdrawIssue failureType={state.currentStep.failureType} />;
        case 'withdraw-pending':
            return <WithdrawSuccess />;
    }
});
